import {Component, OnInit, ViewChild} from '@angular/core';
import {AppLanguageService} from '../../i18n/app.language.service';
import {concatMap, finalize, take, takeUntil} from 'rxjs/operators';
import {LicenseService} from "./license.service";
import {Destroyable} from "../../angular/component/destruction/destroyable.interface";
import {Subject} from "rxjs";
import {SelfDestruct} from "../../angular/component/destruction/self-destruct";
import {once} from "../../helpers/once";
import {load, LoadsData} from "../../angular/component/loading/loads-data";

@Component({
  selector: 'app-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.scss']
})
export class LicenseComponent implements OnInit, Destroyable, LoadsData {
  public destroyed$ = new Subject<this>();
  public content: string;
  public loading: boolean;

  constructor(
    private readonly service: AppLanguageService,
    private readonly license: LicenseService,
    ) {
  }

  ngOnInit() {
    return load(this.fetchLicense(), this, 'content').subscribe();
  }

  private fetchLicense() {
    return this.service.getStartingLanguage().pipe(
      concatMap(culture => this.license.getLicense(culture)),
      once(),
      takeUntil(this.destroyed$),
    );
  }


  ngOnDestroy() {
    SelfDestruct(this);
  }

}
